var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/elements/horizontalCalender.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\r\n<div class=\"table-view no-gutters ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"bulkedit")?"unsortable":""), env.opts.autoescape);
output += "\">\r\n    ";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("header"))(env, context, frame, runtime, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
output += t_1;
output += "\r\n    <div class=\"row horizontal-agenda no-gutters\">\r\n        <div class=\"col-12\" style=\"\">\r\n            <div class=\"card card-primary\" style=\"\">\r\n                <div style=\"overflow: hidden auto; height: 731px;\">\r\n                ";
var t_3;
t_3 = 0;
frame.set("rowIndex", t_3, true);
if(frame.topLevel) {
context.setVariable("rowIndex", t_3);
}
if(frame.topLevel) {
context.addExport("rowIndex", t_3);
}
output += "\r\n                    ";
frame = frame.push();
var t_6 = env.getFilter("groupby").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Data")),"Rows"),"DueDateRaw");
if(t_6) {var t_4;
if(runtime.isArray(t_6)) {
var t_5 = t_6.length;
for(t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4][0]
frame.set("day", t_6[t_4][0]);
var t_8 = t_6[t_4][1]
frame.set("data", t_6[t_4][1]);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "\r\n                        ";
if((lineno = 80, colno = 53, runtime.callWrap(runtime.memberLookup(((lineno = 80, colno = 41, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"moment"), "window[\"moment\"]", context, [t_7]))),"format"), "the return value of (window[\"moment\"])[\"format\"]", context, ["x"])) < (lineno = 80, colno = 87, runtime.callWrap(runtime.memberLookup(((lineno = 80, colno = 74, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"moment"), "window[\"moment\"]", context, [runtime.contextOrFrameLookup(context, frame, "date")]))),"format"), "the return value of (window[\"moment\"])[\"format\"]", context, ["x"]))) {
output += "\r\n                            <table class=\"table table-hover table-striped table-danger table-bordered mb-0\">\r\n                        ";
;
}
else {
output += "\r\n                            <table class=\"table table-hover table-striped table-bordered mb-0\">\r\n                        ";
;
}
output += "\r\n                            <tbody>\r\n                                <tr class=\"table-active bg-secondary\">\r\n                                    <td class=\"table-active\" colspan=\"4\">\r\n                                        <strong>\r\n                                            <a><i class=\"fas fa-calendar-day\"></i> ";
output += runtime.suppressValue((lineno = 89, colno = 109, runtime.callWrap(runtime.memberLookup(((lineno = 89, colno = 97, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"moment"), "window[\"moment\"]", context, [t_7]))),"format"), "the return value of (window[\"moment\"])[\"format\"]", context, ["LL"])), env.opts.autoescape);
output += "</a>\r\n                                        </strong>\r\n                                        <strong class=\"float-right\">\r\n                                            <a>";
output += runtime.suppressValue((lineno = 92, colno = 73, runtime.callWrap(runtime.memberLookup(((lineno = 92, colno = 61, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"moment"), "window[\"moment\"]", context, [t_7]))),"format"), "the return value of (window[\"moment\"])[\"format\"]", context, ["L"])), env.opts.autoescape);
output += "</a>\r\n                                        </strong>\r\n                                    </td>\r\n                                </tr>\r\n                                ";
frame = frame.push();
var t_11 = t_8;
if(t_11) {var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("item", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\r\n                                    <tr data-row-index=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "rowIndex"), env.opts.autoescape);
output += "\" data-subject=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"Subject"), env.opts.autoescape);
output += "\" data-key=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"ID"), env.opts.autoescape);
output += "\" data-keyreference=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"KeyReference"), env.opts.autoescape);
output += "\">\r\n                                        <td width=\"160px\" class=\"text-center\">\r\n                                            <!-- Type 1 Outgoing order -->\r\n                                            ";
if(runtime.memberLookup((t_12),"TaskDescription") == "IncomingItem") {
output += "\r\n                                                <span class=\"badge badge-info\"><i class=\"fas fa-arrow-down\"></i> ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),runtime.memberLookup((t_12),"TaskDescription")), env.opts.autoescape);
output += "</span>\r\n                                            ";
;
}
else {
if(runtime.memberLookup((t_12),"TaskDescription") == "OutgoingItem") {
output += "\r\n                                                <span class=\"badge badge-success\"><i class=\"fas fa-arrow-up\"></i> ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),runtime.memberLookup((t_12),"TaskDescription")), env.opts.autoescape);
output += "</span>\r\n                                            ";
;
}
else {
if(runtime.memberLookup((t_12),"TaskDescription") == "Invoice") {
output += "\r\n                                                <span class=\"badge badge-secondary\"><i class=\"fas fa-file-invoice\"></i> ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),runtime.memberLookup((t_12),"TaskDescription")), env.opts.autoescape);
output += "</span>\r\n                                            ";
;
}
else {
output += "\r\n                                                <span class=\"badge badge-secondary\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),runtime.memberLookup((t_12),"TaskDescription")), env.opts.autoescape);
output += "</span>\r\n                                            ";
;
}
;
}
;
}
output += "\r\n                                        </td>\r\n                                        <td width=\"40px;\" class=\"text-center\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"Amount"), env.opts.autoescape);
output += "</td>\r\n                                        <td>\r\n                                            <a> <strong>";
output += runtime.suppressValue(runtime.memberLookup((t_12),"ID"), env.opts.autoescape);
output += " </strong>- ";
output += runtime.suppressValue(runtime.memberLookup((t_12),"CustomerID"), env.opts.autoescape);
output += ": ";
output += runtime.suppressValue(runtime.memberLookup((t_12),"CustomerCompanyName"), env.opts.autoescape);
output += " <i>";
output += runtime.suppressValue(runtime.memberLookup((t_12),"Reference"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.memberLookup((t_12),"OtherDescription"), env.opts.autoescape);
output += "</i> <span class=\"float-right\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"UserCreated"), env.opts.autoescape);
output += "</span></a>\r\n                                        </td>\r\n                                    </tr>\r\n                                    ";
var t_13;
t_13 = runtime.contextOrFrameLookup(context, frame, "rowIndex") + 1;
frame.set("rowIndex", t_13, true);
if(frame.topLevel) {
context.setVariable("rowIndex", t_13);
}
if(frame.topLevel) {
context.addExport("rowIndex", t_13);
}
output += "\r\n                                ";
;
}
}
frame = frame.pop();
output += "\r\n                            </tbody>\r\n                        </table>\r\n                    ";
;
}
} else {
t_4 = -1;
var t_5 = runtime.keys(t_6).length;
for(var t_14 in t_6) {
t_4++;
var t_15 = t_6[t_14];
frame.set("day", t_14);
frame.set("data", t_15);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "\r\n                        ";
if((lineno = 80, colno = 53, runtime.callWrap(runtime.memberLookup(((lineno = 80, colno = 41, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"moment"), "window[\"moment\"]", context, [t_14]))),"format"), "the return value of (window[\"moment\"])[\"format\"]", context, ["x"])) < (lineno = 80, colno = 87, runtime.callWrap(runtime.memberLookup(((lineno = 80, colno = 74, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"moment"), "window[\"moment\"]", context, [runtime.contextOrFrameLookup(context, frame, "date")]))),"format"), "the return value of (window[\"moment\"])[\"format\"]", context, ["x"]))) {
output += "\r\n                            <table class=\"table table-hover table-striped table-danger table-bordered mb-0\">\r\n                        ";
;
}
else {
output += "\r\n                            <table class=\"table table-hover table-striped table-bordered mb-0\">\r\n                        ";
;
}
output += "\r\n                            <tbody>\r\n                                <tr class=\"table-active bg-secondary\">\r\n                                    <td class=\"table-active\" colspan=\"4\">\r\n                                        <strong>\r\n                                            <a><i class=\"fas fa-calendar-day\"></i> ";
output += runtime.suppressValue((lineno = 89, colno = 109, runtime.callWrap(runtime.memberLookup(((lineno = 89, colno = 97, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"moment"), "window[\"moment\"]", context, [t_14]))),"format"), "the return value of (window[\"moment\"])[\"format\"]", context, ["LL"])), env.opts.autoescape);
output += "</a>\r\n                                        </strong>\r\n                                        <strong class=\"float-right\">\r\n                                            <a>";
output += runtime.suppressValue((lineno = 92, colno = 73, runtime.callWrap(runtime.memberLookup(((lineno = 92, colno = 61, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"moment"), "window[\"moment\"]", context, [t_14]))),"format"), "the return value of (window[\"moment\"])[\"format\"]", context, ["L"])), env.opts.autoescape);
output += "</a>\r\n                                        </strong>\r\n                                    </td>\r\n                                </tr>\r\n                                ";
frame = frame.push();
var t_18 = t_15;
if(t_18) {var t_17 = t_18.length;
for(var t_16=0; t_16 < t_18.length; t_16++) {
var t_19 = t_18[t_16];
frame.set("item", t_19);
frame.set("loop.index", t_16 + 1);
frame.set("loop.index0", t_16);
frame.set("loop.revindex", t_17 - t_16);
frame.set("loop.revindex0", t_17 - t_16 - 1);
frame.set("loop.first", t_16 === 0);
frame.set("loop.last", t_16 === t_17 - 1);
frame.set("loop.length", t_17);
output += "\r\n                                    <tr data-row-index=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "rowIndex"), env.opts.autoescape);
output += "\" data-subject=\"";
output += runtime.suppressValue(runtime.memberLookup((t_19),"Subject"), env.opts.autoescape);
output += "\" data-key=\"";
output += runtime.suppressValue(runtime.memberLookup((t_19),"ID"), env.opts.autoescape);
output += "\" data-keyreference=\"";
output += runtime.suppressValue(runtime.memberLookup((t_19),"KeyReference"), env.opts.autoescape);
output += "\">\r\n                                        <td width=\"160px\" class=\"text-center\">\r\n                                            <!-- Type 1 Outgoing order -->\r\n                                            ";
if(runtime.memberLookup((t_19),"TaskDescription") == "IncomingItem") {
output += "\r\n                                                <span class=\"badge badge-info\"><i class=\"fas fa-arrow-down\"></i> ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),runtime.memberLookup((t_19),"TaskDescription")), env.opts.autoescape);
output += "</span>\r\n                                            ";
;
}
else {
if(runtime.memberLookup((t_19),"TaskDescription") == "OutgoingItem") {
output += "\r\n                                                <span class=\"badge badge-success\"><i class=\"fas fa-arrow-up\"></i> ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),runtime.memberLookup((t_19),"TaskDescription")), env.opts.autoescape);
output += "</span>\r\n                                            ";
;
}
else {
if(runtime.memberLookup((t_19),"TaskDescription") == "Invoice") {
output += "\r\n                                                <span class=\"badge badge-secondary\"><i class=\"fas fa-file-invoice\"></i> ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),runtime.memberLookup((t_19),"TaskDescription")), env.opts.autoescape);
output += "</span>\r\n                                            ";
;
}
else {
output += "\r\n                                                <span class=\"badge badge-secondary\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),runtime.memberLookup((t_19),"TaskDescription")), env.opts.autoescape);
output += "</span>\r\n                                            ";
;
}
;
}
;
}
output += "\r\n                                        </td>\r\n                                        <td width=\"40px;\" class=\"text-center\">";
output += runtime.suppressValue(runtime.memberLookup((t_19),"Amount"), env.opts.autoescape);
output += "</td>\r\n                                        <td>\r\n                                            <a> <strong>";
output += runtime.suppressValue(runtime.memberLookup((t_19),"ID"), env.opts.autoescape);
output += " </strong>- ";
output += runtime.suppressValue(runtime.memberLookup((t_19),"CustomerID"), env.opts.autoescape);
output += ": ";
output += runtime.suppressValue(runtime.memberLookup((t_19),"CustomerCompanyName"), env.opts.autoescape);
output += " <i>";
output += runtime.suppressValue(runtime.memberLookup((t_19),"Reference"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.memberLookup((t_19),"OtherDescription"), env.opts.autoescape);
output += "</i> <span class=\"float-right\">";
output += runtime.suppressValue(runtime.memberLookup((t_19),"UserCreated"), env.opts.autoescape);
output += "</span></a>\r\n                                        </td>\r\n                                    </tr>\r\n                                    ";
var t_20;
t_20 = runtime.contextOrFrameLookup(context, frame, "rowIndex") + 1;
frame.set("rowIndex", t_20, true);
if(frame.topLevel) {
context.setVariable("rowIndex", t_20);
}
if(frame.topLevel) {
context.addExport("rowIndex", t_20);
}
output += "\r\n                                ";
;
}
}
frame = frame.pop();
output += "\r\n                            </tbody>\r\n                        </table>\r\n                    ";
;
}
}
}
frame = frame.pop();
output += "\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"bulkedit") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Data")),"Totals")),"RowCount")),"Value") > 0) {
output += "<div class=\"table-footer clearfix sticky-div stick-to-bottom ml-2 mr-2\">\r\n\t\t\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"pagination") && !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"bulkedit")) {
output += "<ul class=\"pagination\">\r\n\t\t\t\t\t\t<li class=\"button button-menu material-icons\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"First"), env.opts.autoescape);
output += "\" data-window-event=\"page:";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"pagination")),"first") || "", env.opts.autoescape);
output += "\" ";
output += runtime.suppressValue((!runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"pagination")),"first")?"disabled":""), env.opts.autoescape);
output += ">&#xe045;</li>\r\n\t\t\t\t\t\t<li class=\"button button-menu material-icons\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Previous"), env.opts.autoescape);
output += "\" data-window-event=\"page:";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"pagination")),"prev") || "", env.opts.autoescape);
output += "\" ";
output += runtime.suppressValue((!runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"pagination")),"prev")?"disabled":""), env.opts.autoescape);
output += ">&#xe314;</li>\r\n\t\t\t\t\t\t";
frame = frame.push();
var t_23 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"pagination")),"sequence");
if(t_23) {var t_22 = t_23.length;
for(var t_21=0; t_21 < t_23.length; t_21++) {
var t_24 = t_23[t_21];
frame.set("item", t_24);
frame.set("loop.index", t_21 + 1);
frame.set("loop.index0", t_21);
frame.set("loop.revindex", t_22 - t_21);
frame.set("loop.revindex0", t_22 - t_21 - 1);
frame.set("loop.first", t_21 === 0);
frame.set("loop.last", t_21 === t_22 - 1);
frame.set("loop.length", t_22);
output += "<li class=\"page ";
output += runtime.suppressValue((runtime.memberLookup((t_24),"current")?"current":""), env.opts.autoescape);
output += "\" data-window-event=\"page:";
output += runtime.suppressValue(runtime.memberLookup((t_24),"page"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_24),"page"), env.opts.autoescape);
output += "</li>\r\n\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t\t<li class=\"button button-menu material-icons\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Next"), env.opts.autoescape);
output += "\" data-window-event=\"page:";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"pagination")),"next") || "", env.opts.autoescape);
output += "\" ";
output += runtime.suppressValue((!runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"pagination")),"next")?"disabled":""), env.opts.autoescape);
output += ">&#xe315;</li>\r\n\t\t\t\t\t\t<li class=\"button button-menu material-icons\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Last"), env.opts.autoescape);
output += "\" data-window-event=\"page:";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"pagination")),"last") || "", env.opts.autoescape);
output += "\" ";
output += runtime.suppressValue((!runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"pagination")),"last")?"disabled":""), env.opts.autoescape);
output += ">&#xe044;</li>\r\n\t\t\t\t\t</ul>\r\n\t\t\t\t";
;
}
output += "\r\n\r\n\t\t\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Totals") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Totals")),"length") > 0) {
output += "\r\n\t\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t";
frame = frame.push();
var t_27 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Totals");
if(t_27) {var t_26 = t_27.length;
for(var t_25=0; t_25 < t_27.length; t_25++) {
var t_28 = t_27[t_25];
frame.set("col", t_28);
frame.set("loop.index", t_25 + 1);
frame.set("loop.index0", t_25);
frame.set("loop.revindex", t_26 - t_25);
frame.set("loop.revindex0", t_26 - t_25 - 1);
frame.set("loop.first", t_25 === 0);
frame.set("loop.last", t_25 === t_26 - 1);
frame.set("loop.length", t_26);
output += "<div class=\"fake-button button button-menu no-hover no-action\">\r\n\t\t\t\t\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((t_28),"Title"), env.opts.autoescape);
output += ": ";
output += runtime.suppressValue(runtime.memberLookup((t_28),"Value"), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t</div>";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t</div>\r\n\t\t\t\t";
;
}
output += "\r\n\t\t\t\t\r\n\t\t\t\t<div class=\"fake-button button button-menu no-hover no-action\">\r\n\t\t\t\t\t";
if(!runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Options")),"DisableSelection")) {
output += "\r\n\t\t\t\t\t\t<span data-select-count title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"AmountSelectedRows"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"selection")),"length"), env.opts.autoescape);
output += "</span>\r\n\t\t\t\t\t\t/\r\n\t\t\t\t\t";
;
}
output += "\r\n\t\t\t\t\t<span title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"TotalAmountRows"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Data")),"Totals")),"RowCount")),"Value"), env.opts.autoescape);
output += "</span>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t";
;
}
output += "\r\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_header(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\r\n        <div class=\"table-form sticky-div ml-1 mr-1 mt-1\">\r\n            <select class=\"number-of\">\r\n                ";
frame = frame.push();
var t_31 = [15,25,50,100,200,500];
if(t_31) {var t_30 = t_31.length;
for(var t_29=0; t_29 < t_31.length; t_29++) {
var t_32 = t_31[t_29];
frame.set("i", t_32);
frame.set("loop.index", t_29 + 1);
frame.set("loop.index0", t_29);
frame.set("loop.revindex", t_30 - t_29);
frame.set("loop.revindex0", t_30 - t_29 - 1);
frame.set("loop.first", t_29 === 0);
frame.set("loop.last", t_29 === t_30 - 1);
frame.set("loop.length", t_30);
output += "\r\n                    <option ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Request")),"Data") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Request")),"Data")),"PageSize") == t_32?"selected":""), env.opts.autoescape);
output += ">";
output += runtime.suppressValue(t_32, env.opts.autoescape);
output += "</option>\r\n                ";
;
}
}
frame = frame.pop();
output += "\r\n            </select>\r\n\r\n            <form class=\"search-bar\">\r\n                <div class=\"search-box\">\r\n                    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"filters")),"usedate") != runtime.contextOrFrameLookup(context, frame, "null")) {
output += "\r\n                        ";
frame = frame.push();
var t_35 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"filters")),"date");
if(t_35) {var t_34 = t_35.length;
for(var t_33=0; t_33 < t_35.length; t_33++) {
var t_36 = t_35[t_33];
frame.set("filter", t_36);
frame.set("loop.index", t_33 + 1);
frame.set("loop.index0", t_33);
frame.set("loop.revindex", t_34 - t_33);
frame.set("loop.revindex0", t_34 - t_33 - 1);
frame.set("loop.first", t_33 === 0);
frame.set("loop.last", t_33 === t_34 - 1);
frame.set("loop.length", t_34);
if(runtime.memberLookup((t_36),"value")) {
output += "<span class=\"filter\" data-window-event=\"remove-date-query:";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\">\r\n                                    <span class=\"close material-icons\" style=\"font-size:inherit;\">&#xe5cd;</span>\r\n                                    <span>";
output += runtime.suppressValue(runtime.memberLookup((t_36),"text"), env.opts.autoescape);
output += ": ";
output += runtime.suppressValue(runtime.memberLookup((t_36),"value"), env.opts.autoescape);
output += "</span>\r\n                                </span>\r\n                                ";
;
}
else {
output += "<div class=\"dropdown filter-option date-picker\" data-type=\"Date\" data-replace>\r\n                                    <button class=\"toggle-menu button button-menu\">\r\n                                        <span>";
output += runtime.suppressValue(runtime.memberLookup((t_36),"text"), env.opts.autoescape);
output += "</span> \r\n                                        <span class=\"material-icons\" style=\"font-size:inherit;\">&#xe5c5;</span>\r\n                                    </button>\r\n                                    <input type=\"hidden\" class=\"date\" data-index=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\">\r\n                                </div>";
;
}
;
}
}
frame = frame.pop();
output += "\r\n                    ";
;
}
output += "\r\n\r\n                    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Filters")) {
output += "\r\n                        ";
frame = frame.push();
var t_39 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Filters");
if(t_39) {var t_38 = t_39.length;
for(var t_37=0; t_37 < t_39.length; t_37++) {
var t_40 = t_39[t_37];
frame.set("filter", t_40);
frame.set("loop.index", t_37 + 1);
frame.set("loop.index0", t_37);
frame.set("loop.revindex", t_38 - t_37);
frame.set("loop.revindex0", t_38 - t_37 - 1);
frame.set("loop.first", t_37 === 0);
frame.set("loop.last", t_37 === t_38 - 1);
frame.set("loop.length", t_38);
if(runtime.memberLookup((t_40),"Type") == "List") {
output += "\r\n                            <div class=\"filter-option right\">\r\n                                <select data-filter-target=\"";
output += runtime.suppressValue(runtime.memberLookup((t_40),"Target"), env.opts.autoescape);
output += "\">\r\n                                    ";
frame = frame.push();
var t_43 = runtime.memberLookup((t_40),"Options");
if(t_43) {var t_42 = t_43.length;
for(var t_41=0; t_41 < t_43.length; t_41++) {
var t_44 = t_43[t_41];
frame.set("item", t_44);
frame.set("loop.index", t_41 + 1);
frame.set("loop.index0", t_41);
frame.set("loop.revindex", t_42 - t_41);
frame.set("loop.revindex0", t_42 - t_41 - 1);
frame.set("loop.first", t_41 === 0);
frame.set("loop.last", t_41 === t_42 - 1);
frame.set("loop.length", t_42);
output += "\r\n                                        <option ";
output += runtime.suppressValue((runtime.memberLookup((t_40),"Selected") == runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0")?"selected":""), env.opts.autoescape);
output += " value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_44),"Key"), env.opts.autoescape);
output += "</option>\r\n                                    ";
;
}
}
frame = frame.pop();
output += "\r\n                                </select>\r\n                            </div>\r\n                            ";
;
}
if(runtime.memberLookup((t_40),"Type") == "Treeview") {
output += "\r\n                            <div class=\"dropdown right filter-option\">\r\n                                <div class=\"button button-menu fake-button toggle-menu\">\r\n                                    ";
output += runtime.suppressValue(runtime.memberLookup((t_40),"text"), env.opts.autoescape);
output += "\r\n                                </div>\r\n                                <div class=\"menu hide tree-view white\">\r\n                                    ";
output += runtime.suppressValue((lineno = 48, colno = 47, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "makeBranch"), "makeBranch", context, [t_40,runtime.memberLookup((t_40),"list")])), env.opts.autoescape);
output += "\r\n                                </div>\r\n                            </div>\r\n                            ";
;
}
;
}
}
frame = frame.pop();
output += "\r\n                    ";
;
}
output += "\r\n\r\n                    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Request")),"Data") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Request")),"Data")),"Search") && runtime.memberLookup(((lineno = 55, colno = 98, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"getSearchColumns"), "window[\"getSearchColumns\"]", context, []))),"length") > 0) {
output += "\r\n                        ";
frame = frame.push();
var t_47 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Request")),"Data")),"Search");
if(t_47) {var t_46 = t_47.length;
for(var t_45=0; t_45 < t_47.length; t_45++) {
var t_48 = t_47[t_45];
frame.set("searchObj", t_48);
frame.set("loop.index", t_45 + 1);
frame.set("loop.index0", t_45);
frame.set("loop.revindex", t_46 - t_45);
frame.set("loop.revindex0", t_46 - t_45 - 1);
frame.set("loop.first", t_45 === 0);
frame.set("loop.last", t_45 === t_46 - 1);
frame.set("loop.length", t_46);
output += "\r\n                            ";
var t_49;
t_49 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0");
frame.set("offset", t_49, true);
if(frame.topLevel) {
context.setVariable("offset", t_49);
}
if(frame.topLevel) {
context.addExport("offset", t_49);
}
output += "\r\n                            ";
frame = frame.push();
var t_52 = t_48;
if(t_52) {var t_50;
if(runtime.isArray(t_52)) {
var t_51 = t_52.length;
for(t_50=0; t_50 < t_52.length; t_50++) {
var t_53 = t_52[t_50][0]
frame.set("columnSelection", t_52[t_50][0]);
var t_54 = t_52[t_50][1]
frame.set("searchTerm", t_52[t_50][1]);
frame.set("loop.index", t_50 + 1);
frame.set("loop.index0", t_50);
frame.set("loop.revindex", t_51 - t_50);
frame.set("loop.revindex0", t_51 - t_50 - 1);
frame.set("loop.first", t_50 === 0);
frame.set("loop.last", t_50 === t_51 - 1);
frame.set("loop.length", t_51);
output += "\r\n                                <div class=\"filter\" data-window-event=\"remove-text-query:";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "offset"), env.opts.autoescape);
output += "\">\r\n                                    <span class=\"close material-icons\" style=\"font-size:inherit;\">&#xe5cd;</span>\r\n                                    <span>";
output += runtime.suppressValue(t_54, env.opts.autoescape);
output += "</span>\r\n                                </div>\r\n                            ";
;
}
} else {
t_50 = -1;
var t_51 = runtime.keys(t_52).length;
for(var t_55 in t_52) {
t_50++;
var t_56 = t_52[t_55];
frame.set("columnSelection", t_55);
frame.set("searchTerm", t_56);
frame.set("loop.index", t_50 + 1);
frame.set("loop.index0", t_50);
frame.set("loop.revindex", t_51 - t_50);
frame.set("loop.revindex0", t_51 - t_50 - 1);
frame.set("loop.first", t_50 === 0);
frame.set("loop.last", t_50 === t_51 - 1);
frame.set("loop.length", t_51);
output += "\r\n                                <div class=\"filter\" data-window-event=\"remove-text-query:";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "offset"), env.opts.autoescape);
output += "\">\r\n                                    <span class=\"close material-icons\" style=\"font-size:inherit;\">&#xe5cd;</span>\r\n                                    <span>";
output += runtime.suppressValue(t_56, env.opts.autoescape);
output += "</span>\r\n                                </div>\r\n                            ";
;
}
}
}
frame = frame.pop();
output += "\r\n                        ";
;
}
}
frame = frame.pop();
output += "\r\n\r\n                        <div class=\"search-input-container\">\r\n                            <input class=\"input ignore-next ignore-reset\" placeholder=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"PlaceholderSearch"), env.opts.autoescape);
output += "\" >\r\n                        </div>\r\n                    ";
;
}
output += "\r\n                </div>\r\n            </form>\r\n        </div>\r\n    ";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_header: b_header,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/elements/horizontalCalender.html"] , dependencies)